<template>
<div style="display:inline-block;">
    <div style="position:relative;height:100%;width:100%">
    <transition-group name="x-slow-fade">
        <img v-if="imageNumber == 1" class="round white-border shadow absolute" width="100%" height="100%" :src="src1" alt="" key="img1"/>
        <img v-if="imageNumber == 2" class="round white-border shadow absolute" width="100%" height="100%" :src="src2" alt="" key="img2"/>
    </transition-group>
    </div>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'

export default {
    data() {
        return {
            imageNumber: 1,
            src1: '',
            src2: '',
        }
    },

    components: {
        
    },
    
    props: {
        src: String,
        size: {
            type: Number,
            default: 50,
        }
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        function1() {

        },
    },

    watch: {
        'src': {
            handler: function(newVal) {
                if(this.imageNumber == 1) {
                    this.src2 = newVal
                    this.imageNumber = 2
                } else {
                    this.src1 = newVal
                    this.imageNumber = 1
                }
            }, 
            immediate: true,
        }
    },

    created() {

    }
}
</script>

<style scoped>
    .absolute {
        position:absolute;
    }
</style>




// WEBPACK FOOTER //
// ImageFader.vue?0fd53310